'use strict';

module.exports = require('./is-implemented')()
	? String.prototype.contains
	: require('./shim');



/*****************
 ** WEBPACK FOOTER
 ** /Users/gaearon/p/react-devtools/~/es5-ext/string/#/contains/index.js
 ** module id = 206
 ** module chunks = 0
 **/